import TabsExtended from '../../js/src/tabs-extended.js';

(function ($) {
    let initTabsFlexible = new TabsExtended('[block-name="tabs-extended"]');
})(jQuery);
